import { StorageUtils } from 'xmgoing-utils';
import { computed } from 'vue';
import { useAppStore } from '@/store/modules/app';

// 大海深蓝 | 白色简约
const FRAME_TYPE = ['classicBlue', 'technology'];

export function useAppFrame() {
  const appStore = useAppStore();

  /**
   * 以 pinia 中的 layout 为准。
   * 注意：本模块可能在 main.ts 的 initLayout 之前就被 Layout 链路导入，
   * 因此不能在模块顶层一次性读取 Storage（无痕首次登录时会读到空值并锁死为默认布局）。
   * setupStore / initAppConfigStore 发生在 initLayout 之后，此时 appStore.layout 已是正确值。
   */
  const layoutFrame = computed(
    () => appStore.layout || StorageUtils.getItem('layout') || 'defaultFrameCom',
  );

  const isFrameType = computed(() => FRAME_TYPE.includes(layoutFrame.value));

  const setFrameType = (layout: string) => {
    StorageUtils.addItem('layout', layout);
    appStore.setLayout(layout);
  };

  const getTechnologyFrameTextColor = computed(() => {
    return {
      color: layoutFrame.value === 'technology' ? '#1F58A7' : '#FFFFFF',
    };
  });

  return {
    setFrameType,
    isFrameType,
    layoutFrame,
    getTechnologyFrameTextColor,
  };
}
